export default [
  { text: 'Estudiante', value: 'student' },
  { text: 'Recién graduado', value: 'recently-graduated' },
  { text: 'Graduado con experiencia', value: 'experienced-graduated' }
]